import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveContainerPricingAdminMutationVariables = Types.Exact<{
  store_default_container_prices_string: Types.Scalars['String'];
  consumer_overdue_prices_string: Types.Scalars['String'];
}>;


export type SaveContainerPricingAdminMutation = { __typename?: 'Mutation', saveContainerPricingAdmin: { __typename?: 'AdminContainerPricing', store_default_container_prices_string: string, consumer_overdue_prices_string: string } };


export const SaveContainerPricingAdminDocument = gql`
    mutation SaveContainerPricingAdmin($store_default_container_prices_string: String!, $consumer_overdue_prices_string: String!) {
  saveContainerPricingAdmin(
    store_default_container_prices_string: $store_default_container_prices_string
    consumer_overdue_prices_string: $consumer_overdue_prices_string
  ) {
    store_default_container_prices_string
    consumer_overdue_prices_string
  }
}
    `;
export type SaveContainerPricingAdminMutationFn = Apollo.MutationFunction<SaveContainerPricingAdminMutation, SaveContainerPricingAdminMutationVariables>;

/**
 * __useSaveContainerPricingAdminMutation__
 *
 * To run a mutation, you first call `useSaveContainerPricingAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveContainerPricingAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveContainerPricingAdminMutation, { data, loading, error }] = useSaveContainerPricingAdminMutation({
 *   variables: {
 *      store_default_container_prices_string: // value for 'store_default_container_prices_string'
 *      consumer_overdue_prices_string: // value for 'consumer_overdue_prices_string'
 *   },
 * });
 */
export function useSaveContainerPricingAdminMutation(baseOptions?: Apollo.MutationHookOptions<SaveContainerPricingAdminMutation, SaveContainerPricingAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveContainerPricingAdminMutation, SaveContainerPricingAdminMutationVariables>(SaveContainerPricingAdminDocument, options);
      }
export type SaveContainerPricingAdminMutationHookResult = ReturnType<typeof useSaveContainerPricingAdminMutation>;
export type SaveContainerPricingAdminMutationResult = Apollo.MutationResult<SaveContainerPricingAdminMutation>;
export type SaveContainerPricingAdminMutationOptions = Apollo.BaseMutationOptions<SaveContainerPricingAdminMutation, SaveContainerPricingAdminMutationVariables>;